import { Component, Input } from '@angular/core';

import { IconComponent } from '../../common/icon/icon.component';
import type { IconName } from '../../common/icon/icons.type';
import { RtInput } from '../../utils/rt-input';

@Component({
  selector: 'rt-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.less'],
  host: {
    '[class.checked]': 'checked',
    '[class.disabled]': 'disabled',
    '[class.has-lens-icon]': 'hasLensIcon',
    '[class.has-no-tb-margin]': 'hasNoTBMargin',
    '[class.has-color-text-color]': 'hasColorTextColor',
    '[class.has-align-items-start]': 'hasAlignItemsStart',
    '(click)': 'handleClick($event)',
    '(focus)': 'focus.emit($event)',
    '(blur)': 'blur.emit($event)',
  },
  imports: [IconComponent],
})
export class RadioComponent extends RtInput<string | boolean | null> {
  @Input() public value: string | true = true;
  @Input() public checked: boolean = false;
  @Input() public hasLensIcon: boolean = false;
  @Input() public hasNoTBMargin: boolean = false;
  @Input() public hasColorTextColor: boolean = false;
  @Input() public hasAlignItemsStart: boolean = false;
  @Input() public fullWidthLabel: boolean = false;

  public handleClick($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    if (!this.disabled && !this.readOnly) {
      this.handleChange(!this.checked ? this.value || true : null);
    }
  }

  public getIconName(): IconName {
    // TODO
    return this.hasLensIcon ? <any>'lens' : 'check';
  }

  protected setValue(value: string | boolean): void {
    this.checked = this.value === value;
  }
}
